<template>

  <nav class="navbar navbar-expand-xl">

    <div class="collapse navbar-collapse" id="navbarSupportedContent" :class="{'show': isMenuOpen}">
      <div class="du-navbar">
        <ul class="nav navbar-nav" :class="isDarkPage ? 'dark-theme' : 'light-theme'">
          <li v-if="isAuthenticated" class="nav-item mb-2 mb-md-0 parent-nav-item">
            <router-link class="nav-link" tag="a" to="/" @click="closeMenu()">OVERZICHT TOETSEN</router-link>
            <span v-bind:class="(activePage === 'RequestView')?'d-block' : ''" class="active-dot"></span>
            <div v-if="isAdmin" class="nav-item mb-2 mb-md-0 child-nav-item">
              <router-link class="nav-link" tag="a" to="/kortingscodes" @click="closeMenu()">KORTINGSCODES</router-link>
            </div>
          </li>

          <li class="nav-item auth-buttons">
            <Auto0></Auto0>
          </li>
        </ul>
      </div>
    </div>
  </nav>

</template>


<script>
import {useUserStore} from '@/store/user'
import {storeToRefs} from 'pinia'
import Auto0 from "@/components/auth0.vue";
import {useAuth0} from '@auth0/auth0-vue';
import {useTheme} from "@/components/utils/theme";
import {checkPermissionByEmail, checkAdminByEmail} from "@/components/utils/check-permission-by-email";
import {Collapse} from 'bootstrap';

let userStore
let userVar
let loggedIn
export default {
  name: 'Navigation',
  components: {Auto0},

  setup() {
    const {isAuthenticated} = useAuth0();
    const {isDarkPage} = useTheme()
    const {isUserExclusive} = checkPermissionByEmail();
    const {isAdmin} = checkAdminByEmail();
    // const { emit } = defineEmits(['toggleMenu']);
    userStore = useUserStore()
    const {user, isLoggedIn} = storeToRefs(userStore)
    userVar = user.value
    loggedIn = isLoggedIn.value
    return {
      isDarkPage,
      user,
      isLoggedIn,
      isAuthenticated,
      isUserExclusive,
      isAdmin,
    }
  },

  data() {
    return {
      fillCount: 0,
      isMenuOpen: false
    };
  },

  props: {
    activePage: {
      type: String
    },
    toggleCollapseMenu: {
      type: Boolean
    }
  },

  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    closeMenu() {
      this.$emit('toggleMenu');
      const navbar = document.getElementById('navbarSupportedContent');
      if (navbar.classList.contains('show')) {
        const bsCollapse = new Collapse(navbar, {toggle: false});
        bsCollapse.hide();
      }
    }
  },

  watch: {
    user: {
      // This will let Vue know to look inside the array
      deep: true,
    },
    toggleCollapseMenu(newValue) {
      this.isMenuOpen = newValue
    }
  },

}


</script>
<style>
.navbar-nav {
  align-items: center;
}

.nav-item {
  position: relative;
}

.active-dot {
  background-color: #A1FFE1;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  top: 14px;
  right: 0;
  position: absolute;
  display: none;

  &.d-block {
    display: block !important;
  }
}


</style>
